export default "__VITE_ASSET__BgV5$_W3__"